// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_33JAB","closeIcon":"_3MCms","sliderWrapper":"_3LAxk","title":"_19cX-","item":"_2QjlY"};